import { controls } from "../../controls";

const rp1201 = {
  label: "Employee Bio Data",
  pageLabel: "Employee Bio Date",
  starting: true,
  url: "rp1201",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [



    ...controls.displayText({ tab: "filter", label: "Employee Code", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "employee_code", width: "col-sm-2", placeHolder: "Pf Number" }),


    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", width: "col-sm-2" }),



    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    //...controls.displayText({tab:"filter",label: "Product Code",width:"col-sm-2"}),
    //...controls.product({tab: "filter"}),
    //...controls.showData({tab:"filter",data: "product_code_display", name: "product_code_display",width:"col-sm-2",displaytype:'camelcase'}),

    //...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    //...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),



    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Eployee Bio Data",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        accessor: "branch",
        Header: "Branch",
        width: 80,
        rwidth: 50
      },

      {
        accessor: "pf_no",
        Header: "Pf No",
        width: 80,
        rwidth: 50
      },

      {
        accessor: "employee_name",
        Header: "Employee Name",
        width: 200,
        rwidth: 80
      },

      {
        accessor: "desg",
        Header: "Designation",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "grade",
        Header: "Grade",
        //type:"currency",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "department",
        Header: "Department",
        //type:"currency",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "dob",
        Header: "DOB",
        type: "date",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "join_date",
        Header: "Join Date",
        type: "date",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "prmn_date",
        Header: "Parmanant Date",
        type: "date",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "retirement_date",
        Header: "Retirement Date",
        type: "date",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "pan_no",
        Header: "PAN",
        //type:"Date",
        width: 100,
        rwidth: 50
      },


      {
        accessor: "aadhar",
        Header: "Aadhar No",
        width: 100,
        rwidth: 50
      },

      {
        accessor: "mob_no",
        Header: "Mobile Number",
        // type:"currency",
        width: 100,
        rwidth: 50
      },

    ]
  }
};

export default rp1201;